import React from 'react';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import FileCopyRoundedIcon from '@mui/icons-material/FileCopyRounded';
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';

import classes from './ChallengeStatusCell.module.scss';
import {
  CHALLENGE_STATUS,
  ChallengeStatusType,
} from '../../../../constants/challengeStatus';
import { Status } from '../../../../../shared/components/ui-components';
import { GridTableCell } from '../../../../../shared/components/table-components';

type ChallengeStatusCellProps = {
  status: ChallengeStatusType;
};

const ChallengeStatusCell = ({ status }: ChallengeStatusCellProps) => {
  const renderStatus = () => {
    switch (status) {
      case CHALLENGE_STATUS.ACTIVE:
        return (
          <Status icon={<CheckCircleRoundedIcon fontSize="small" color="success" />}>
            Active
          </Status>
        );
      case CHALLENGE_STATUS.DRAFT:
        return (
          <Status icon={<FileCopyRoundedIcon fontSize="small" color="info" />}>
            Draft
          </Status>
        );
      case CHALLENGE_STATUS.FINISHED:
        return (
          <Status icon={<DoneAllRoundedIcon fontSize="small" color="tertiary" />}>
            Finished
          </Status>
        );
      case CHALLENGE_STATUS.PUBLISHED:
        return (
          <Status
            icon={
              <SendRoundedIcon
                fontSize="small"
                color="warning"
                className={classes.publishedIcon}
              />
            }
          >
            Published
          </Status>
        );
      default:
        return null;
    }
  };

  return <GridTableCell>{renderStatus()}</GridTableCell>;
};

export { ChallengeStatusCell };
